// Fetch actions
export const FETCH_LEAD_ACTIVITY_REQUEST = 'FETCH_LEAD_ACTIVITY_REQUEST';
export const FETCH_LEAD_ACTIVITY_SUCCESS = 'FETCH_LEAD_ACTIVITY_SUCCESS';
export const FETCH_LEAD_ACTIVITY_FAILURE = 'FETCH_LEAD_ACTIVITY_FAILURE';

// State management
export const CLEAR_ACTIVITY_STATE = 'CLEAR_ACTIVITY_STATE';
export const UPDATE_EMAIL_READ_STATUS = 'UPDATE_EMAIL_READ_STATUS';
